import type { ComponentType } from 'react';
import { registerSettingsCard } from '../../components/SettingsCards';
import type { SettingsCardProps } from '../../components/SettingsCards';
import { SettingsEditor } from '../../components/SettingsEditor';
import { ComplianceGroupCard } from '../safety/ComplianceGroupCard';
import { NfcGroupCard, SafetyGroupCard, SafetySiteCard } from '../safety/GroupCards';
import { CapacityCard } from './CapacityCard';
import { ContactlessCard } from './ContactlessCard';

/**
 * Phase 3 wiring (W23): the module settings cards on the site and group pages. The site and group pages draw one section per
 * module through `SettingsCards`, which looks a card up by module key. Some modules have a custom card at one level only; the
 * other level keeps the generic settings form.
 * Evacuation and lone working register their own cards in their routes files (both levels), so they are not repeated here.
 */
type ByScope = Partial<Record<SettingsCardProps['scope'], ComponentType<SettingsCardProps>>>;

function register(moduleKey: string, cards: ByScope): void {
  registerSettingsCard(moduleKey, function ScopedCard(props: SettingsCardProps) {
    const Card = cards[props.scope];
    if (Card) return <Card {...props} />;
    return <SettingsEditor moduleKey={props.moduleKey} base={`/${props.scope}/${props.scopeId}/settings`} canEdit={props.canEdit} />;
  });
}

const contactless: ComponentType<SettingsCardProps> = ({ scopeId }) => <ContactlessCard siteId={scopeId} />;
const capacity: ComponentType<SettingsCardProps> = ({ scopeId }) => <CapacityCard siteId={scopeId} />;

register('safety-check', { groups: SafetyGroupCard, sites: SafetySiteCard });
register('compliance', { groups: ComplianceGroupCard });
register('nfc-cards', { groups: NfcGroupCard });
register('contactless', { sites: contactless });
register('occupancy', { sites: capacity });
